/**
 * Minified by jsDelivr using Terser v5.3.5.
 * Original file: /npm/bootstrap-select@1.14.0-beta2/js/bootstrap-select.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
